import React from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import { useSidebar } from '../sidebar/Sidebar';
import { Menu, MenuTrigger, MenuContent, MenuItem, MenuSeparator, MenuLabel } from '../menu';
import { useAuth } from '../../providers/logincontext';
import styles from './UserInfo.module.css';

export interface UserInfoProps {
  name: string;
  avatarUrl?: string;
  action?: React.ReactNode;
}

export const UserInfo = ({ name, avatarUrl, action }: UserInfoProps) => {
  const { collapsed } = useSidebar();
  const { logout } = useAuth();

  return (
    <Menu>
      <MenuTrigger>
        <div className={styles.root}>
          <div className={styles.avatarWrap}>
            {avatarUrl ? (
              <img src={avatarUrl} alt={name} className={styles.avatar} />
            ) : (
              <div className={styles.avatarPlaceholder}>
                {name.charAt(0).toUpperCase()}
              </div>
            )}
          </div>

          {!collapsed && (
            <div className={styles.details}>
              <span className={styles.name}>{name}</span>
            </div>
          )}

          {action && <div className={styles.action}>{action}</div>}
        </div>
      </MenuTrigger>

      <MenuContent side="top" align="start">
        <MenuLabel>{name}</MenuLabel>
        <MenuSeparator />
        <MenuItem icon={<LogoutOutlined />} variant="destructive" onClick={logout}>
          Logout
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};
